import React, { useState, useEffect } from "react";
import axios from "axios";

import {
  Badge,
  Table,
  Col,
  Row,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  Spinner,
} from "reactstrap/";
import { GetCookieToken, GetCookieData } from "../../Cookie/GetCookie";
import { Fragment } from "react";

import EditData from "./EditData";
import LoadingData from "../../TESTPage/LoadingData";
import FadeIn from "react-fade-in/lib/FadeIn";
import { useNavigate } from "react-router-dom";
import { CheckPosition } from "../../Function/CheckPosition";
import { CheckSubAdmin } from "../../Function/CheckSubAdmin";

const API_URL = process.env.REACT_APP_API_CORS;

function ViewDataUser(props) {
  const {userInfo} = props
  const navigate = useNavigate();
  const user = GetCookieData("userData");

  const [data, setData] = useState([]);
  const [dataInfo, setDataInfo] = useState([]);
  const token = GetCookieToken("userToken");

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    const url = `${API_URL}/api/users/${user.user_id}`;

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then(response => {
        setData(() => response.data.result);
        setDataInfo(() => response.data.info);
      })
      .catch(error => console.error("Error:", error));
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    if (userInfo) {
      if (
        CheckPosition(userInfo?.position) ||
        CheckSubAdmin(userInfo?.positionSubAdmin)
      ) 
      {
        navigate("/setdata");
      }
    }
  }, [userInfo]);

  return (
    <Fragment>
        <FadeIn>
          <Row>
            <Col>
              <Table
                className="align-middle"
                striped
                style={{
                  overflow: "scroll",
                }}
                responsive
              >
                <thead className="table-light" style={{ whiteSpace: "nowrap" }}>
                  <tr>
                    <th>ลำดับ</th>
                    <th>ชื่อ-นามสกุล</th>
                    <th>Log In Name</th>
                    <th>หมายเลขภายใน</th>
                    <th></th>
                  </tr>
                </thead>
                {loading ? 
                  <tbody>
                    <tr>
                      <td colSpan={5}>
                        <LoadingData />
                      </td>
                    </tr>
                  </tbody> 
                  :
                  <tbody>
                    {data.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="text-center fs-5">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td style={{ fontSize: "16px" }}>1</td>
                        <td style={{ width: "560px" }}>{data.user_name}</td>
                        <td>
                          <Badge color="success" className="p-2 bg-opacity-10">
                            <span className="text-success fs-6">
                              {data.user_login}
                            </span>
                          </Badge>
                        </td>
                        <td className="text-nowrap text-center">{user.user_intercom}</td>
                        <td>
                          <EditData id={user.user_id} />
                        </td>
                      </tr>
                    )}
                  </tbody>
                }
              </Table>
              <Row>
                {/* <Col>
                  <Badge color="secondary" className="p-2 bg-opacity-10 mx-2">
                    <div
                      style={{ fontWeight: "bolder" }}
                      className="text-secondary fs-6 pt-1"
                    >
                      ทั้งหมด 1 รายการ
                    </div>
                  </Badge>
                </Col> */}
                <Col className="d-flex justify-content-center justify-content-sm-end">
                  <Pagination className="mt-3">
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink onClick={() => setCurrentPage(1)}>
                        หน้าแรก
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink
                        onClick={() => setCurrentPage(currentPage - 1)}
                      >
                        ย้อนกลับ
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem active>
                      <PaginationLink>หน้า {currentPage}</PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled>
                      <PaginationLink
                        onClick={() => setCurrentPage(dataInfo.currentPage + 1)}
                      >
                        ถัดไป
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem disabled>
                      <PaginationLink
                        onClick={() => setCurrentPage(dataInfo.totalPage)}
                      >
                        หน้าสุดท้าย
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </Col>
              </Row>
            </Col>
          </Row>
        </FadeIn>
    </Fragment>
  );
}

export default ViewDataUser;
